import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import getVersionControl from 'pxc-editor-web/environment_modules/web_component/helpers/getVersionControl';
import { colors } from '@/globalStyles';
import { setShortcutModalOpen } from '@/store/actions/cmme';
import { getBuildedMatfileTemplate } from '@/helpers/matfile';
import { Label } from '@/components';
import {
  ContextMenuStyled,
  MaterialInfoBlockStyled,
  MaterialInfoHeaderStyled,
  MaterialInfoBodyStyled,
  OptionsBlockStyled,
  OptionStyled,
  FooterStyled,
} from './styles';

const MaterialInfoContextMenu = (props) => {
  const { handleClose } = props;
  const colorSchema = useSelector(state => state.core.colorSchema);
  const intl = useIntl();
  const dispatch = useDispatch();
  const matfileTemplate = getBuildedMatfileTemplate();
  const fileName = matfileTemplate?.file_name;
  const name = matfileTemplate?.name;
  const materialFileName = name || fileName || '-';
  const colorSchemaArticleNumber = colorSchema?.article_number || '-';
  const matFileType = matfileTemplate?.type || '-';
  const versionTranslate = intl.formatMessage({
    id: 'app.editor.modal.materialInfo.version',
    defaultMessage: 'Version',
  });
  const matFileVersion = `${versionTranslate} ${
    matfileTemplate.format_version
  }.${matfileTemplate.material_version || 0}`;
  const versionControl = getVersionControl();
  const creatorAppName = versionControl.creator_app_name;
  const { major, minor, patch } = versionControl.creator_app_version;
  const creatorVersion = `App version ${major}.${minor}.${patch}`;

  const handleShortcutsClick = () => {
    handleClose();
    dispatch(setShortcutModalOpen(true));
  };

  return (
    <ContextMenuStyled>
      <MaterialInfoBlockStyled>
        <MaterialInfoHeaderStyled>
          <Label>
            <FormattedMessage
              id="app.editor.modal.materialInfo"
              defaultMessage="Material info"
            />
          </Label>
        </MaterialInfoHeaderStyled>
        <MaterialInfoBodyStyled>
          <Box sx={{ fontSize: '16px', color: colors.primary }}>
            <Box sx={{ marginBottom: '10px' }}>
              <FormattedMessage
                id="app.editor.modal.materialInfo.matfileName"
                defaultMessage="Mat. file name:"
              />
            </Box>
            <Box sx={{ marginBottom: '10px' }}>
              <FormattedMessage
                id="app.editor.modal.materialInfo.matfileId"
                defaultMessage="Mat. file ID:"
              />
            </Box>
            <Box sx={{ marginBottom: '10px' }}>
              <FormattedMessage
                id="app.editor.modal.materialInfo.matfileType"
                defaultMessage="Mat. file type:"
              />
            </Box>
            <Box>
              <FormattedMessage
                id="app.editor.modal.materialInfo.versionAndRevision"
                defaultMessage="Version and revision:"
              />
            </Box>
          </Box>
          <Box sx={{ fontSize: '16px', color: colors.dimGray }}>
            <Box sx={{ marginBottom: '10px' }}>{materialFileName}</Box>
            <Box sx={{ marginBottom: '10px' }}>{colorSchemaArticleNumber}</Box>
            <Box sx={{ marginBottom: '10px' }}>{matFileType}</Box>
            <Box sx={{ marginBottom: '10px' }}>{matFileVersion}</Box>
          </Box>
        </MaterialInfoBodyStyled>
      </MaterialInfoBlockStyled>
      <OptionsBlockStyled>
        <OptionStyled onClick={handleShortcutsClick}>
          <Label>
            <FormattedMessage
              id="debug.keyboardShortcuts"
              defaultMessage="Keyboard shortcuts"
            />
          </Label>
        </OptionStyled>
      </OptionsBlockStyled>
      <FooterStyled>
        <Label>
          <span>{creatorAppName}</span>
        </Label>
        <Label>
          <span>{creatorVersion}</span>
        </Label>
      </FooterStyled>
    </ContextMenuStyled>
  );
};

export default MaterialInfoContextMenu;
